// @ts-nocheck — mixin methods are composed onto BackendService at runtime; instance API is typed via adminBackendServiceInterface.d.ts.
import type BaseBackendService from '../BaseBackendService';
import { NewsImportResult, NewsItemAdmin, NewsScanResult } from '../../models/NewsItem';

// Inline import() types are used in the return signatures below so the generated
// adminBackendServiceInterface.d.ts resolves them without a hand-maintained import.
export const adminBackendServiceNewsMixin = {
  listNewsItems(
    includeArchived: boolean = false,
  ): Promise<import('../../models/NewsItem').NewsItemAdmin[]> {
    const qs = includeArchived ? '?includeArchived=1' : '';
    return this.authApiGetAuthed(
      `admin/news${qs}`,
      'Network error while loading news items',
      (json) => (json?.data ?? []) as NewsItemAdmin[],
    );
  },

  getNewsSource(): Promise<{ sourceUrl: string }> {
    return this.authApiGetAuthed(
      'admin/news/source',
      'Network error while loading the news source URL',
      (json) => json?.data as { sourceUrl: string },
    );
  },

  scanNewsSource(): Promise<import('../../models/NewsItem').NewsScanResult> {
    return this.authApiMutateAuthed(
      'admin/news/scan',
      'POST',
      undefined,
      (json) => json?.data as NewsScanResult,
    );
  },

  importNewsItems(sourceRefs: string[]): Promise<import('../../models/NewsItem').NewsImportResult> {
    return this.authApiMutateAuthed(
      'admin/news/import',
      'POST',
      { sourceRefs },
      (json) => json?.data as NewsImportResult,
    );
  },

  createNewsItem(
    body: Record<string, unknown>,
  ): Promise<import('../../models/NewsItem').NewsItemAdmin> {
    return this.authApiMutateAuthed(
      'admin/news',
      'POST',
      body,
      (json) => json?.data as NewsItemAdmin,
    );
  },

  updateNewsItem(
    externalId: string,
    body: Record<string, unknown>,
  ): Promise<import('../../models/NewsItem').NewsItemAdmin> {
    return this.authApiMutateAuthed(
      `admin/news/${externalId}`,
      'PUT',
      body,
      (json) => json?.data as NewsItemAdmin,
    );
  },

  refreshNewsItemFromSource(
    externalId: string,
  ): Promise<import('../../models/NewsItem').NewsItemAdmin> {
    return this.authApiMutateAuthed(
      `admin/news/${externalId}/refresh`,
      'POST',
      undefined,
      (json) => json?.data as NewsItemAdmin,
    );
  },

  publishNewsItem(externalId: string): Promise<import('../../models/NewsItem').NewsItemAdmin> {
    return this.authApiMutateAuthed(
      `admin/news/${externalId}/publish`,
      'POST',
      undefined,
      (json) => json?.data as NewsItemAdmin,
    );
  },

  archiveNewsItem(externalId: string): Promise<void> {
    return this.authApiDeleteVoid(`admin/news/${externalId}`);
  },

  unarchiveNewsItem(externalId: string): Promise<void> {
    return this.authApiMutateAuthed(
      `admin/news/${externalId}/unarchive`,
      'POST',
      undefined,
      () => undefined,
    );
  },
} satisfies ThisType<BaseBackendService>;
